import React from "react";
import { Link } from "react-router-dom";
import PriceBox from "./Reusable/PriceBox";

const AsideProductItem = ({ item }) => {
  function formatUrlString(inputString) {
    // Pretvara sva velika slova u mala
    const lowercaseString = inputString.toLowerCase();

    // Zamjenjuje sve razmake i specijalne karaktere sa -
    const formattedString = lowercaseString
      .replace(/[^\w\s]/gi, "")
      .replace(/\s+/g, "-");

    return formattedString;
  }

  return (
    <div className="product product-widget">
      <figure className="product-media">
        <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
          <img src={item?.images?.[0]} alt="Product" width="300" height="338" />

          {item.fixPrice > item.cashPrice && (
            <div className="product-label-group">
              <label className="product-label label-discount">
                % NA POPUSTU
              </label>
            </div>
          )}

          {/* <div className="product-label-group">
            {item.new === 1 && (
              <label className="product-label label-new">Novo</label>
            )}
            {parseFloat(item.cena_sa_popustom) < parseFloat(item.cena) && (
              <label className="product-label label-discount">
                % NA POPUSTU
              </label>
            )}
            {item.action === 1 && (
              <label className="product-label label-hot">Akcija</label>
            )}
          </div> */}
        </Link>
      </figure>
      <div className="product-details">
        <h4 className="product-name">
          <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
            {item.name}
          </Link>
        </h4>

        <div className="product-price product-price-holder-custom product-detail-price-custom product-item-vertical-list">
          <PriceBox item={item} showWebPriceTitle={false} />
        </div>
      </div>
    </div>
  );
};

export default AsideProductItem;
